import { Button, Dialog, DialogContent, DialogTitle, Divider, FormHelperText, IconButton, InputAdornment, Stack, TextField, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import DraggablePaper from "../common/DraggablePaper";
import { CONTENT_COLOR, MAIN_HEADER_COLOR } from "../../models/Constants";
import dayjs, { Dayjs } from "dayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useEffect, useState } from "react";

export type UserForm = {
    userName : string;
    email : string;
    dateOfBirth : string;
}

export type AddEditUserProps = {
    data: UserForm;
    mode:string;
    onOK: (data: any) => void;
    onCancel: () => void;
};

export const AddEditUserDialog = (props: AddEditUserProps) => {
    //#region fields
    const { data, mode, onOK, onCancel } = props;
    const [dateOfBirth,setDateOfBirth] = useState<Dayjs | null>(data.dateOfBirth && mode != 'ADD' ? dayjs(data.dateOfBirth): null)

    useEffect(()=>{clearErrors()},[dateOfBirth])
    // 初期値設定
    const initialValue : UserForm = {
        ...data,
    }

    const { control, handleSubmit, formState: { errors }, setValue, getValues, setError, clearErrors } = useForm<UserForm>({
        mode: "all",
        criteriaMode: "all",
        defaultValues: mode == 'ADD' ? {} : initialValue,
    })
    //#endregion fields

    //#region methods
    // Submitイベント
    const handleEditSubmit = (value: any, event: any) => {
        clearErrors()
        if(dateOfBirth && dateOfBirth?.format('YYYY-MM-DD') != "Invalid Date")
        {
            const request = createRequestData(value);
            onOK(request);
        }
        else
        {
            setError("dateOfBirth",{ type: 'custom', message:"必須項目です。入力してください。"})
        }
    }
    
    // FormデータからRequestデータを作成する
    const createRequestData = (formValue : UserForm) => {       
        let request = {
            ...formValue,
            dateOfBirth: dateOfBirth?.format('YYYY-MM-DD'),
            mode:mode
        };
        return request;
    }

    //#endregion methods

    return (
        <>
            <Dialog open={true} maxWidth={"sm"} fullWidth
                PaperComponent={
                    DraggablePaper
                }
            >
                <DialogTitle 
                    onMouseOver={(e : any) => e.target.style.cursor = 'move'}
                    style={{ paddingTop: '2px', paddingBottom: '2px', background: MAIN_HEADER_COLOR, color: 'white' }}
                >
                    <Typography variant="h5" color={CONTENT_COLOR}>{mode =='ADD' ?"受検者情報新規登録":"受検者情報新規編集"}</Typography>
                </DialogTitle>
                <Divider/>
                <DialogContent style={{paddingTop: '10px', display: 'flex', alignItems: 'flex-end'}}>
                    <div style={{width: '100%', marginTop:"10px"}}>
                        <form onSubmit={handleSubmit(handleEditSubmit)}>
                            <Stack spacing={3}>
                                <Stack>
                                    <Controller
                                        name="email"
                                        control={control}
                                        rules={
                                            {
                                                required: "必須項目です。入力してください。",
                                                pattern: {
                                                    value: /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                                                    message: "メールアドレス形式で入力してください。"
                                                }
                                            }
                                        }
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                type="text"
                                                size="small"
                                                label={<Typography variant="body1">メールアドレス</Typography>}
                                                error={!!errors?.email}
                                                helperText={errors?.email?.message}
                                            />
                                        )}
                                    />
                                </Stack>
                                <Stack>
                                    <Controller
                                        name="userName"
                                        control={control}
                                        rules={{ required: "必須項目です。入力してください。"}}
                                        render={({ field }) => (
                                            <TextField
                                                {...field}
                                                fullWidth
                                                type="text"
                                                size="small"
                                                label={<Typography variant="body1">氏名</Typography>}
                                                error={!!errors?.userName}
                                                helperText={errors?.userName?.message}
                                            />
                                        )}
                                    />
                                </Stack>
                                <Stack>
                                <Controller
                                    name="dateOfBirth"
                                    control={control}
                                    render={({ field }) => (
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                label={'生年月日'}
                                                {...field}
                                                value={dateOfBirth}
                                                defaultValue={dateOfBirth}
                                                onChange={setDateOfBirth}
                                                format="YYYY/MM/DD"
                                                slotProps={{
                                                    textField: {
                                                        sx: {
                                                            '& .MuiInputBase-root': {
                                                            color: errors.dateOfBirth ?'red' :'',
                                                            borderColor: errors.dateOfBirth ?'red' :'',
                                                            },
                                                            '& .MuiInputLabel-root': {
                                                            color: errors.dateOfBirth ?'red' :'',
                                                            },
                                                            '& .MuiOutlinedInput-root': {
                                                            '& fieldset': {
                                                                borderColor: errors.dateOfBirth ?'red' :'',
                                                            },
                                                            '&:hover fieldset': {
                                                                borderColor: errors.dateOfBirth ?'red' :'',
                                                            },
                                                            '&.Mui-focused fieldset': {
                                                                borderColor: errors.dateOfBirth ?'red' :'',
                                                            },
                                                            },
                                                        },
                                                    InputProps: {
                                                        startAdornment: (
                                                            <InputAdornment
                                                                    sx={{
                                                                    color: "#979797",
                                                                    paddingRight:'35px',
                                                                    right:0,
                                                                    position:'absolute',
                                                                    cursor:'pointer'
                                                                    }}
                                                                    position="end"
                                                            >
                                                            </InputAdornment>
                                                        ),
                                                    },
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    )}
                                />
                                {
                                    !!errors?.dateOfBirth &&
                                    <FormHelperText style={{ color: 'red'}}>{errors?.dateOfBirth?.message as any}
                                    </FormHelperText>
                                }
                                </Stack>
                            </Stack>
                            <Stack direction='row' justifyContent="flex-end" gap={2} sx={{ mt: 4 }}>
                                <Button color="inherit" variant="contained" onClick={onCancel} sx={{fontWeight:'bold'}}>キャンセル</Button>
                                <Button variant="contained" type="submit" sx={{fontWeight:'bold'}}>{mode =='ADD' ?"追加":"保存"}</Button>
                            </Stack>
                        </form>
                    </div>                    
                </DialogContent>
            </Dialog>
        </>
    )
}
export default AddEditUserDialog;